'use client';

import type { ReactElement } from 'react';
import { Ccontainer } from '@/components/ui/Ccontainer';
import { FooterState } from './footerModels';
import {
  CfooterLinkActionButton,
  CfooterStateActionButton,
} from './CfooterActionButton';

const FOOTER_REVEAL_EMAIL_BUTTON_WRAPPER = 'revealEmailButtonWrapper';
const FOOTER_REVEAL_EMAIL_LABEL = 'Reveal Email';
const FOOTER_ABOUT_US_BUTTON_WRAPPER = 'aboutUsButtonWrapper';
const FOOTER_ABOUT_US_LABEL = 'About Us';
const FOOTER_PRIVACY_LINK = 'privacyLink';
const FOOTER_PRIVACY_BUTTON_WRAPPER = 'privacyButtonWrapper';
const FOOTER_PRIVACY_LABEL = 'Privacy';
const FOOTER_TERMS_LINK = 'termsLink';
const FOOTER_TERMS_BUTTON_WRAPPER = 'termsButtonWrapper';
const FOOTER_TERMS_LABEL = 'Terms';

export interface CfooterActionRowProps {
  footerState: FooterState;
  privacyHref: string;
  termsHref: string;
  onRevealEmail: () => void;
  onAboutUs: () => void;
  onPrivacy: () => void;
  onTerms: () => void;
}

export function CfooterActionRow({
  footerState,
  privacyHref,
  termsHref,
  onRevealEmail,
  onAboutUs,
  onPrivacy,
  onTerms,
}: CfooterActionRowProps): ReactElement {

  return (
      <Ccontainer
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        contentWrapperStyle={{ gap: '20px' }}
      >
        <CfooterStateActionButton
          dataName={FOOTER_REVEAL_EMAIL_BUTTON_WRAPPER}
          label={FOOTER_REVEAL_EMAIL_LABEL}
          isActive={footerState === FooterState.EmailRevealed}
          onClick={onRevealEmail}
        />
        <CfooterStateActionButton
          dataName={FOOTER_ABOUT_US_BUTTON_WRAPPER}
          label={FOOTER_ABOUT_US_LABEL}
          isActive={footerState === FooterState.AboutUs}
          onClick={onAboutUs}
        />
        <CfooterLinkActionButton
          href={privacyHref}
          dataName={FOOTER_PRIVACY_LINK}
          wrapperName={FOOTER_PRIVACY_BUTTON_WRAPPER}
          label={FOOTER_PRIVACY_LABEL}
          onClick={onPrivacy}
        />
        <CfooterLinkActionButton
          href={termsHref}
          dataName={FOOTER_TERMS_LINK}
          wrapperName={FOOTER_TERMS_BUTTON_WRAPPER}
          label={FOOTER_TERMS_LABEL}
          onClick={onTerms}
        />
      </Ccontainer>
  );
}
